import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SalePrintData, SaleService } from '@app/core';
import * as nunjucks from 'nunjucks';
// import * as qr from 'qr-image';

@Component({
  selector: 'app-print-preview',
  templateUrl: './print-preview.component.html',
  styleUrls: ['./print-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PrintPreviewComponent implements OnInit {
  htmlTemplate =
    '<!DOCTYPE html><html lang="{{ language }}"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><link href="https://fonts.googleapis.com/css2?family=Fira+Mono:wght@400;700&display=swap" rel="stylesheet"><style>body {\r\n        width: 100%;\r\n      }\r\n      .invoice {\r\n        font-family: \'Fira Mono\', monospace;\r\n        font-size: 3mm;\r\n        width: 100%;\r\n        max-width: 210mm;\r\n        margin: 0 auto;\r\n        padding: 5mm;\r\n        box-sizing: border-box;\r\n\r\n        p {\r\n          line-height: 4.2mm;\r\n          margin: 0;\r\n          padding: 0;\r\n        }\r\n\r\n        .sp-1 {\r\n          margin-top: 1mm;\r\n        }\r\n\r\n        .sp-2 {\r\n          margin-top: 2mm;\r\n        }\r\n\r\n        .sp-3 {\r\n          margin-top: 3mm;\r\n        }\r\n\r\n        .txt-medium {\r\n          font-size: 3.5mm;\r\n        }\r\n\r\n        .txt-large {\r\n          font-size: 4mm;\r\n        }\r\n\r\n        .strikethrough {\r\n          text-decoration: line-through;\r\n        }\r\n\r\n        .tab-1 {\r\n          margin-left: 3mm;\r\n        }\r\n\r\n        .two-columns {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n\r\n        .two-columns :first-child {\r\n          text-align: left;\r\n        }\r\n\r\n        .two-columns :last-child {\r\n          text-align: right;\r\n        }\r\n\r\n        h1 {\r\n          text-align: center;\r\n          margin: 0;\r\n          padding: 0.14 0;\r\n        }\r\n        .header {\r\n          margin-top: 4mm;\r\n          text-align: center;\r\n        }\r\n        .footer {\r\n          text-align: center;\r\n          margin-bottom: 4mm;\r\n        }\r\n        .header {\r\n        }\r\n        .footer {\r\n        }\r\n        .details {\r\n        }\r\n\r\n        .details .item {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n        .details .item:last-child {\r\n        }\r\n\r\n        @media (min-width: 110mm) {\r\n          .invoice {\r\n            width: 100%;\r\n          }\r\n          .details .item {\r\n            grid-template-columns: repeat(4, 1fr);\r\n          }\r\n        }\r\n\r\n        .totals .total-row {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n        .total-label {\r\n          text-align: left;\r\n        }\r\n        .total-value {\r\n          text-align: right;\r\n          font-weight: bold;\r\n        }\r\n        .logo {\r\n          text-align: center;\r\n          margin-bottom: 5mm;\r\n        }\r\n        .logo img {\r\n          width: 100%;\r\n          max-width: 60mm;\r\n          height: auto;\r\n        }\r\n        .qr-code {\r\n          text-align: center;\r\n        }\r\n        .qr-code img {\r\n          width: 100%;\r\n          max-width: 2.5cm;\r\n          height: auto;\r\n        }\r\n        hr {\r\n          border: 0;\r\n          border-top: 0.26mm dashed black;\r\n          margin: 1mm 0;\r\n        }\r\n\r\n        .legends {\r\n          .legend {\r\n            margin-bottom: 1mm;\r\n          }\r\n          .legend:last-child {\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n      }</style></head><body><div class="invoice"><div class="header">{% if store_logo_url %}<div class="logo"><img src="{{ store_logo_url }}" alt="Company Logo"></div>{% endif %}<p class="txt-large"><strong>{{ store_name | uppercase }}</strong></p><p>{{ store_address }}</p><p>RUC: {{ store_id_number }}</p><p><strong>{{ invoice_label | capitalize }}</strong></p><p><strong>{{ invoice_number }}</strong></p><p>Fecha de emisión: {{ invoice_issue_date }}</p></div><div class="details sp-3">{% if customer_name %}<p><strong>Cliente:</strong> {{ customer_name | uppercase }}</p><p><strong>{{ customer_document_type }}:</strong> {{ customer_id_number }}</p>{% if customer_address %}<p><strong>Dirección:</strong> {{ customer_address }}</p>{% endif %} {% endif %}<hr><div class="items">{% for item in items %}<div class="item"><div><span>{{ item.description }}</span><p class="tab-1">{{ item.quantity }} X {{ item.unit_price | currency(locale, currency_code) }} {% if item.discount_percentage %} Desct. {{ item.discount_percentage | round(2) }}% ({{ item.unit_discount | currency(locale, currency_code) }}) {% endif %}</p>{% if item.note %}<p class="tab-1">Nota: {{ item.note }}</p>{% endif %}</div><div><span>{{ item.total_price | currency(locale, currency_code) }}</span> {% if item.discount_percentage %}<p class="strikethrough">{{ item.total_base_price | currency(locale, currency_code) }}</p>{% endif %}</div></div>{% endfor %}</div><hr><div class="payments">{% for item in payments %}<div class="item"><span>{{ item.name }}</span> <span>{{ item.amount | currency(locale, currency_code) }}</span> {% if item.change %} <span>Vuelto: {{ item.change | currency(locale, currency_code) }}</span> {% endif %}</div>{% endfor %}</div><hr>{% if note %}<p><strong>Nota:</strong> {{ note }}</p>{% endif %}<div class="totals sp-3"><div class="total-row"><span class="total-label">Subtotal</span> <span class="total-value">{{ subtotal | currency(locale, currency_code) }}</span></div>{% if exempt %}<div class="total-row"><span class="total-label">Exonerado</span> <span class="total-value">{{ exempt | currency(locale, currency_code) }}</span></div>{% endif %} {% if non_taxable %}<div class="total-row"><span class="total-label">Inafecto</span> <span class="total-value">{{ non_taxable | currency(locale, currency_code) }}</span></div>{% endif %}<div class="total-row"><span class="total-label">IGV ({{ vat_rate | default(0) }}%)</span> <span class="total-value">{{ vat | currency(locale, currency_code) }}</span></div><hr><div class="total-row txt-large"><span class="total-label"><strong>Total</strong></span> <span class="total-value">{{ total | currency(locale, currency_code) }}</span></div></div></div><div class="legends sp-3">{% for legend in legends %}<p class="legend">{{ legend | safe }}</p>{% endfor %}</div>{% if invoice_qr_code_url %}<div class="qr-code sp-3"><img src="{{ invoice_qr_code_url }}" alt="QR Code"></div>{% endif %}<div class="footer sp-3"><p>{{ footer }}</p></div></div></body></html>';
  safeHtml: SafeHtml = '';

  env: nunjucks.Environment;

  constructor(private saleService: SaleService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    // Initialize Nunjucks
    this.initNunjucks();

    // Load the sale data and render the template
    // this.saleService.data('64372734-00ae-4f83-b549-bc2bdaa614a0').subscribe((response) => {
    //   if (response.ok) {
    //     this.renderTemplate(response.data!!);
    //   }
    // });

    this.renderTemplate(saleData);
  }

  // Initialize Nunjucks
  initNunjucks(): void {
    // Configurar Nunjucks
    this.env = new nunjucks.Environment(/* Configuración */);

    // Crear el filtro para formatear números como moneda
    this.env.addFilter('currency', function (number, locale = 'en-US', currency = 'USD') {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(number ?? 0);
    });

    // Add uppercase filter
    this.env.addFilter('uppercase', function (text) {
      return text?.toUpperCase() ?? '';
    });

    // Definir el filtro para redondear
    this.env.addFilter('round', function (value, decimalPlaces = 2) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.round((value ?? 0) * factor) / factor;
    });

    // Crea un filtro personalizado para convertir texto en SVG QR Code
    // this.env.addFilter('qrcode', function (text) {
    //   try {
    //     // Genera el código QR en formato SVG
    //     const qr_svg = qr.imageSync(text, { type: 'svg', ec_level: 'Q' });

    //     // Devuelve el SVG como una cadena
    //     return qr_svg.toString();
    //   } catch (error) {
    //     // Manejo de errores
    //     console.error('Error generating QR code:', error);
    //     return '';
    //   }
    // });
  }

  // Render the template with the provided data
  renderTemplate(data: SalePrintData): void {
    this.env.renderString(this.htmlTemplate, data, (err, res) => {
      if (err) {
        console.error('Error rendering template:', err);
      } else {
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(res!!);
      }
    });
  }
}

const saleData: SalePrintData = {
  version: '2024-09-14T17:20:50.372397Z',
  number: '4AJ6',
  locale: 'es-PE',
  language: 'es',
  country_code: 'PE',
  currency_code: 'PEN',
  store_name: 'ACME Inc.',
  store_address: 'JR. 28 DE JULIO 673',
  store_id_number: '51999999999',
  store_logo_url: 'https://freelogopng.com/images/all_img/1655873659shopify-black-logo.png',
  invoice_number: 'F001-0001',
  invoice_issue_date: '14/09/2024 17:20:48',
  invoice_label: 'Factura Electrónica',
  invoice_qr_code_url:
    'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=248615|495145|4946545484545784|98749654AJ6',
  register_name: 'RUC',
  seller_name: 'ACME Inc.',
  customer_name: 'david Torres',
  customer_document_number: '20601188750',
  customer_document_type: 'DNI',
  customer_address: '',
  note: 'Gracias por su compra',
  items: [
    {
      description: 'PowerBoost Ultra',
      quantity: 1,
      unit_price: 25.42,
      unit_discount: 10.0,
      discount_percentage: 10.567,
      unit_charge: 0.0,
      charge_percentage: 0.0,
      total_base_price: 30.0,
      total_price: 30.0,
      tax: 4.58,
      note: 'Promoción de lanzamiento',
    },
    {
      description: 'Adaptador USB-C a HDMI 4K 60Hz 1.8m',
      quantity: 2,
      unit_price: 25.42,
      unit_discount: 0.0,
      discount_percentage: 0,
      unit_charge: 0.0,
      charge_percentage: 0.0,
      total_base_price: 30.0,
      total_price: 30.0,
      tax: 4.58,
      note: '',
    },
  ],
  payments: [
    {
      name: 'Efectivo',
      amount: 30.0,
    },
  ],
  subtotal: 25.42,
  taxable: 25.42,
  exempt: 25.42,
  non_taxable: 0.0,
  export: 0.0,
  free: 0.0,
  vat_rate: 18.0,
  vat: 4.58,
  excise: 0.0,
  bag: 0.0,
  tax: 4.58,
  total: 30.0,
  legends: [
    'SON: TREINTA  CON 00/100',
    'BIENES TRANSFERIDOS EN LA AMAZONÍA PARA SER CONSUMIDOS EN LA MISMA',
    'FORMA DE PAGO: CONTADO',
  ],
  footer: 'Representación impresa del comprobante electrónico, consulte en https://d.nishi.app',
};

const sale = {
  qrCodeUrl:
    'https://w7.pngwing.com/pngs/144/829/png-transparent-qr-code-information-qr-code-android-qrcode-text-rectangle-monochrome.png',
  created_at: '2024-09-14T17:20:50.372397Z',
  deleted_at: null,
  currency_code: 'PEN',
  country_code: 'PE',
  language: 'es',
  locale: 'es-PE',
  finals: {
    subtotal: 30,
    total: 30,
    total_discount: 0,
    total_tax: 4.58,
  },
  global_charge: 0,
  global_charge_exempt: 0,
  global_discount: 0,
  global_discount_exempt: 0,
  id: '64372734-00ae-4f83-b549-bc2bdaa614a0',
  invoice: {
    id: '59424ce8-1ad1-4753-8053-37e010edc2d1',
    issue_date: '2024-09-14T17:20:48.54563Z',
    number: 'N001-1',
    pdf_url:
      'https://files-dev.nishi.app/invoices/d3c5a635ab0af2c7cdf6c2725073f03572442aaf0b926ed79a70bd71920325b6.pdf',
    sequence_number: 1,
    status: 'created',
    type: 'sale_note',
  },
  issue_date: '2024-09-14T17:20:48.54563Z',
  items: [
    {
      created_at: '2024-09-14T17:20:42.885Z',
      deleted_at: null,
      finals: {
        quantity: 1,
        total_base_price: 30,
        total_discount: 0,
        total_price: 30,
        unit_base_price: 30,
        unit_discount: 0,
        unit_price: 30.000000000048,
      },
      id: 'dbc68301-9204-46ea-a9d8-6d1def7c5327',
      name: 'PowerBoost Ultra',
      price: 25.4237288136,
      price_inc: 30,
      product_id: '00179ee1-3eb7-45ee-aa59-da0b081ad66b',
      quantity: 1,
      sale_type: 'u',
      sku: 'sku-powerboostultra',
      subtotal: 25.4237288136,
      tax_code: '10',
      tax_id: '289754cd-43d4-4af2-b20b-bb495e840019',
      tax_rate: 18,
      tax_type: 'taxable',
      total_bag_tax: 0,
      total_cost: 0,
      total_discount: 0,
      total_excise: 0,
      total_price: 25.42,
      total_sale: 30,
      total_tax: 4.58,
      total_vat: 4.58,
      unit_charge: 0,
      unit_discount: 0,
      unit_price: 25.4237288136,
      unit_tax: 4.5762711864,
      unit_type: 'und',
      unit_value: 25.4237288136,
      units: 1,
    },
  ],
  number: 'TSFR',
  payments: [
    {
      amount: 30,
      id: 'a47dab26-dd07-4e8e-8351-430c1ca06fbe',
      name: 'Efectivo',
      paid_at: '2024-09-14T17:20:48Z',
      payment_id: '4a11931f-685b-4783-84c2-2cfb50d039ae',
      type: 'cash',
    },
  ],
  return_ids: [],
  status: 'completed',
  store: {
    logo_url: 'https://freelogopng.com/images/all_img/1655873659shopify-black-logo.png',
    address: 'JR. 28 DE JULIO 673',
    country: 'PE',
    denomination: 'DOTPEM SOCIEDAD ANONIMA CERRADA - DOTPEM SAC',
    has_riders: true,
    id: '8a899911-5713-42c8-9712-7a4496d1e5a3',
    id_number: '20601188750',
    is_amazon: true,
    name: 'Dotpem',
    time_zone: 'America/Lima',
  },
  subtotal: 25.42,
  tax: {
    code: '10',
    id: '289754cd-43d4-4af2-b20b-bb495e840019',
    name: 'Gravado',
    rate: 18,
    type: 'taxable',
  },
  total_bag_tax: 0,
  total_charge: 0,
  total_cost: 0,
  total_discount: 0,
  total_exempt: 0,
  total_export: 0,
  total_free: 0,
  total_non_taxable: 0,
  total_price: 25.42,
  total_quantity: 1,
  total_sale: 30,
  total_tax: 4.58,
  total_taxable: 25.42,
  total_vat: 4.58,
  type: 'pos',
  updated_at: '2024-09-14T17:20:50.372397Z',
  user: {
    id: 'ce57b6f1-6f49-4c03-8989-4ab0b3b6996a',
    name: 'David Torres',
  },
  version: '2024-09-14T17:20:50.372397Z',
};
